import { SITE_CONFIG } from '../config';

export const SEO_CONFIG = {
  siteName: SITE_CONFIG.BUSINESS.NAME,
  siteUrl: SITE_CONFIG.SITE_URL,
  defaultTitle: 'Maricopa Renovations | Kitchen, Bathroom & Home Remodeling',
  defaultDescription: 'Local kitchen, bathroom, flooring and whole-home remodeling in Maricopa, Arizona. Visit our showroom or schedule a free in-home consultation.',
  defaultImage: SITE_CONFIG.ASSETS.LOGO,
  locale: 'en_US',
  business: {
    name: SITE_CONFIG.BUSINESS.LEGAL_NAME,
    telephone: SITE_CONFIG.BUSINESS.PHONE_E164,
    email: SITE_CONFIG.BUSINESS.EMAIL,
    image: SITE_CONFIG.ASSETS.LOGO,
    priceRange: '$$',
    address: {
      streetAddress: SITE_CONFIG.BUSINESS.STREET,
      addressLocality: SITE_CONFIG.BUSINESS.CITY,
      addressRegion: SITE_CONFIG.BUSINESS.REGION,
      postalCode: SITE_CONFIG.BUSINESS.POSTAL_CODE,
      addressCountry: 'US'
    }
  }
};
